
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import { required, minLength, minValue } from "vuelidate/lib/validators";
import AppLoading from "@/components/UI/AppLoading.vue";

export default Vue.extend({
  name: "AdminEditProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      id: "",
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
    };
  },
  methods: {
    editProduct() {
      store.dispatch("admin/editProduct", {
        id: this.id,
        formData: { image: this.chosenFile, images: this.chosenFiles },
      });
    },
    editProductImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch("admin/updateProductImage", event?.target?.result);
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },
    cancel(): void {
      router.push({ name: "admin-all-products" });
    },
  },
  computed: {
    productDetails() {
      return store.state.admin.productData;
    },
    categories(): any[] {
      const categories = store.state.panel.categories;
      let items: any[] = [];
      categories.forEach((category: any) => {
        const item = {
          title: category.title,
          value: category["_id"],
        };
        items.push(item);
      });
      return items;
    },
    name: {
      get(): string {
        return store.state.admin.productData.name;
      },
      set(value: string): void {
        store.dispatch("admin/updateProductName", value);
      },
    },
    nameError(): string[] {
      const errors: string[] = [];
      if (!this.$v.name?.$dirty) {
        return errors;
      }
      !this.$v.name.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    category: {
      get(): string {
        return store.state.admin.productData.category;
      },
      set(value: string): void {
        store.dispatch("admin/updateProductCategory", value);
      },
    },
    categoryError(): string[] {
      const errors: string[] = [];
      if (!this.$v.category?.$dirty) {
        return errors;
      }
      !this.$v.category.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    amount: {
      get(): number | null {
        return Number(store.state.admin.productData.amount);
      },
      set(value: number): void {
        store.dispatch("admin/updateProductAmount", Number(value));
      },
    },
    amountError(): string[] {
      const errors: string[] = [];
      if (!this.$v.amount?.$dirty) {
        return errors;
      }
      !this.$v.amount.minLength && errors.push("حداقل 4 رقم");
      !this.$v.amount.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    special_sell: {
      get(): number {
        return Number(store.state.admin.productData.special_sell);
      },
      set(value: number): void {
        store.dispatch("admin/updateProductSpecialSell", Number(value));
      },
    },
    specialSellError(): string[] {
      const errors: string[] = [];
      if (!this.$v.special_sell?.$dirty) {
        return errors;
      }
      !this.$v.special_sell.required &&
        errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    inventory: {
      get(): number {
        return Number(store.state.admin.productData.inventory);
      },
      set(value: number): void {
        store.dispatch("admin/updateProductInventory", Number(value));
      },
    },
    inventoryError(): string[] {
      const errors: string[] = [];
      if (!this.$v.inventory?.$dirty) {
        return errors;
      }
      !this.$v.inventory.required && errors.push("تکمیل این فیلد الزامی است");
      !this.$v.inventory.minValue && errors.push("حداقل موجودی محصول: 1 عدد");

      return errors;
    },
    description: {
      get(): string {
        return store.state.admin.productData.description;
      },
      set(value: string): void {
        store.dispatch("admin/updateProductDescription", value);
      },
    },
    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  created() {
    const id = this.$route.query.id;

    if (!id) {
      // set snackbar
      store.commit("app/showSnackbar", {
        message: "ابتدا یک محصول جهت ویرایش انتخاب کنید",
        status: 400,
      });

      // move to the main admin page
      router.push({ name: "admin-all-products" });
    } else {
      this.id = id as string;
      store.dispatch("admin/getProductDetails", id);
    }
  },
  validations: {
    name: {
      required,
    },
    category: {
      required,
    },
    amount: {
      required,
      minLength: minLength(4),
    },
    special_sell: {
      required,
    },
    inventory: {
      required,
      minValue: minValue(1),
    },
    description: {
      required,
    },
  },
});
